import { QtyTypeEnum } from '../enums/qty-type.enum'
import { QtyTypeInterface } from '../interfaces/qty-type.interface'

export const QtyTypes: QtyTypeInterface[] = [
	{
		title: 'orderQtyInput.qty',
		type: QtyTypeEnum.QTY,
		mark: 'orderQtyInput.pcs',
	},
	{
		title: 'orderQtyInput.shareOfPortfolio',
		type: QtyTypeEnum.PERCENT,
		mark: '%',
	},
	{ title: 'orderQtyInput.amount', type: QtyTypeEnum.DOLLAR, mark: '$' },
]
